<!-- section template -->
<template>
  <Layout :class="$style.sectionMemberLevel">
    <BaseBannerJtails :title="currentMerchant.levelSetting.title || '會員等級'" :image="bannerImage" />
    <section class="section">
      <div class="container">
        <div class="row gx-1">
          <div class="sectionMemberLevel__imgBox col-md-6">
            <div
              class="sectionMemberLevel__img"
              :class="{ isNull: !memberLevelList.image }"
              :style="{ backgroundImage: `url('${memberLevelList.images[0] ? memberLevelList.images[0].path : require(`@assets/images/${$globalProjectName}/memberLevel/member@2.jpg`)}')` }"
            >
            </div>
            <div v-if="memberLevelList.description" class="sectionMemberLevel__meta">
              <BaseSectionTitleJtails v-if="!$globalIsDingBeauty" title="等級說明" title-class="color-primary-dark" :description="nlToBr(memberLevelList.description)" />
              <BaseSectionTitleSecondary v-else title="等級說明" :description="nlToBr(memberLevelList.description)" />
            </div>
          </div>
          <div class="sectionMemberLevel__contentBox sectionPrice__priceBox col-md-5 offset-md-1">
            <div :class="$style.priceBox">
              <!-- <div id="sectionPrice" style="position: relative; top: -4rem"></div> -->
              <h3 class="sectionMemberLevel__title">等級方案</h3>
              <template v-if="!!memberLevelList.levels.length">
                <el-collapse v-model="activeMemberLevel" :class="[$style.memberLevelList, { isStyleDingBeauty: $globalIsDingBeauty }]" class="isStyleList" accordion>
                  <template v-for="(memberLevelItem, index) in memberLevelList.levels">
                    <el-collapse-item :key="`memberLevelItem-${index}`" class="memberLevelItem__item" :name="index">
                      <template slot="title">
                        <div class="d-flex align-items-center justify-content-between w-100">
                          <span class="name">
                            {{ memberLevelItem.title }}
                          </span>
                        </div>
                      </template>
                      <div>
                        <div class="description" v-html="nlToBr(memberLevelItem.description)"></div>
                      </div>
                    </el-collapse-item>
                  </template>
                </el-collapse>
              </template>
              <template v-else>
                <BaseNull :image="`${require('@assets/images/reservation/no-record.svg')}`" title="尚無任何等級方案" />
              </template>
            </div>
          </div>
        </div>
      </div>
    </section>
  </Layout>
</template>

<script>
import { authComputed, merchantComputed } from '@store/helpers'
import { nlToBr } from '@utils'
export default {
name:'index6',
  page() {
    return {
      title: this.currentMerchant.levelSetting.title || '會員等級',
    }
  },
  components: {
    Layout: () => import('@layout/main'),
  },
  props: {
    list: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      memberLevelList: this.list || [],
      activeMemberLevel: 0,
    }
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    bannerImage() {
      if (this.currentMerchant.levelSetting.bannerImages.length > 0) {
        return this.currentMerchant.levelSetting.bannerImages[0].path
      } else {
        return require(`@assets/images/${this.$globalProjectName}/memberLevel/banner@2.jpg`)
      }
    },
  },
  mounted() {
    this.tryToFetchMemberLevelList()
  },
  methods: {
    nlToBr,
    async tryToFetchMemberLevelList() {
      // this.memberLevelList = ''
    },
  },
}
</script>

<!-- section style -->
<style lang="scss" module>
.sectionMemberLevel {
  :global {
    .sectionMemberLevel {
      @include unstyled;
      &__imgBox {
        @include max-md {
          margin-bottom: 1rem;
        }
      }

      &__img {
        position: relative;
        padding-top: 59%;
        background-color: $color-bg-default;
        background-position: center;
        background-size: cover;

        &.isNull {
          background-color: transparent;

          &::before,
          &::after {
            display: none;
          }
        }

        &::before {
          position: absolute;
          top: 25%;
          right: 0;
          width: 33px;
          height: 33px;
          content: '';
          background-image: url('~@assets/images/home/section2-pattern-2.svg');
          background-position: center;
          background-size: cover;
          transform: translateX(50%);

          @include max-md {
            width: 18px;
            height: 18px;
          }
        }

        &::after {
          position: absolute;
          bottom: 20%;
          left: 0;
          width: 94px;
          height: 94px;
          content: '';
          background-image: url('~@assets/images/home/section2-pattern-1.svg');
          background-position: center;
          background-size: cover;
          transform: translateX(-50%);

          @include max-md {
            width: 52px;
            height: 52px;
          }
        }
      }
      &__meta {
        margin-top: 1.875rem;
      }
      &__title {
        font-size: 1.125rem;
        font-weight: 500;
        line-height: 1.75;
        color: #3f3a2e;
        @include max-md {
          margin-bottom: 0.5rem;
        }
      }
    }
  }
  .memberLevelList {
    :global {
    }
  }
}
</style>
